function fcFormatUSD(cents){ return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format((Number(cents)||0)/100); }
/* FashionCave Theme JS v2.0 */

// Cart open/close
// Refresh cart drawer items live from Shopify cart
  function refreshCartDrawer() {
    Promise.all([
      fetch((window.fcRoute ? window.fcRoute('cart.js') : '/cart.js')).then(function(r){ return r.json(); }),
      fetch('/cart', {headers:{'Accept':'text/html'}}).then(function(r){ return r.text(); })
    ]).then(function(results) {
      var cart = results[0], html = results[1];
      // Update count badges
      document.querySelectorAll('.cart-badge, #CartCount').forEach(function(el){
        el.textContent = cart.item_count;
      });
      var countEl = document.getElementById('CdCount');
      if (countEl) countEl.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
      // Update subtotal
      var sub = document.getElementById('CdSubtotal');
      if (sub) sub.textContent = '\u20b9' + (cart.total_price / 100).toLocaleString('en-IN');
      // Replace items HTML from live cart page
      var itemsDiv = document.getElementById('CartItems');
      if (itemsDiv) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartItems');
        if (fresh) itemsDiv.innerHTML = fresh.innerHTML;
      }
      // Show/hide footer
      var foot = document.querySelector('.crt-foot');
      if (foot) foot.style.display = cart.item_count > 0 ? '' : 'none';
      // Free shipping bar
      if (typeof updateFsBar === 'function') updateFsBar(cart.total_price / 100);
    }).catch(function(){});
  }

  function openCart() {
    var ov = document.getElementById('cartOv');
    var dr = document.getElementById('cartDr');
    if(ov){
      ov.style.display = 'block';
      ov.style.position = 'fixed';
      ov.style.top = '0'; ov.style.left = '0';
      ov.style.width = '100%'; ov.style.height = '100%';
      ov.style.background = 'rgba(20,20,20,.72)';
      ov.style.zIndex = '1400';
    }
    if(dr){
      dr.style.display = 'flex';
      dr.style.position = 'fixed';
      dr.style.top = '0'; dr.style.left = '0';
      dr.style.width = '100%'; dr.style.height = '100%';
      dr.style.alignItems = 'center';
      dr.style.justifyContent = 'center';
      dr.style.zIndex = '1500';
      dr.style.padding = '16px';
      dr.style.boxSizing = 'border-box';
    }
    document.body.style.overflow = 'hidden';
    // Always fetch fresh cart data when drawer opens
    refreshCartDrawer();
  }
function closeCart() {
  var ov = document.getElementById('cartOv');
  var dr = document.getElementById('cartDr');
  if(ov){ ov.style.display = 'none'; }
  if(dr){ dr.style.display = 'none'; }
  document.body.style.overflow = '';
}

// Cart toggle button
document.getElementById('CartToggle')?.addEventListener('click', openCart);

// Filter tabs
document.querySelectorAll('.ftab').forEach(tab => {
  tab.addEventListener('click', function() {
    document.querySelectorAll('.ftab').forEach(t => t.classList.remove('active'));
    this.classList.add('active');
  });
});

// Color swatches
document.addEventListener('click', e => {
  const swatch = e.target.closest('.cdot');
  if (swatch) {
    swatch.closest('.pc-variants')?.querySelectorAll('.cdot').forEach(x => x.classList.remove('active'));
    swatch.classList.add('active');
  }
  const size = e.target.closest('.szchip');
  if (size) {
    size.closest('.pc-sizes')?.querySelectorAll('.szchip').forEach(x => x.classList.remove('active'));
    size.classList.add('active');
  }
});

// Variant buttons (product page)
document.querySelectorAll('.var-btn').forEach(b => {
  b.addEventListener('click', function() {
    this.closest('.var-opts')?.querySelectorAll('.var-btn').forEach(x => x.classList.remove('active'));
    this.classList.add('active');
  });
});

// ATC — quick add from card
document.addEventListener('click', async e => {
  const btn = e.target.closest('.btn-atc[data-variant-id]');
  if (!btn) return;
  e.preventDefault();
  const orig = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;
  try {
    await fetch((window.fcRoute ? window.fcRoute('cart/add.js') : '/cart/add.js'), {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: btn.dataset.variantId, quantity: 1})
    });
    const cart = await fetch((window.fcRoute ? window.fcRoute('cart.js') : '/cart.js')).then(r => r.json());
    document.querySelectorAll('.cart-badge, #CartCount').forEach(el => el.textContent = cart.item_count);
    btn.textContent = 'Added ✓';
    setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1500);
    openCart();
  } catch(err) {
    btn.textContent = orig;
    btn.disabled = false;
  }
});

// Product form ATC
document.querySelector('form[action="/cart/add"]')?.addEventListener('submit', async function(e) {
  e.preventDefault();
  const btn = this.querySelector('[type="submit"]');
  const orig = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;
  try {
    await fetch((window.fcRoute ? window.fcRoute('cart/add.js') : '/cart/add.js'), { method: 'POST', body: new FormData(this) });
    const cart = await fetch((window.fcRoute ? window.fcRoute('cart.js') : '/cart.js')).then(r => r.json());
    document.querySelectorAll('.cart-badge, #CartCount').forEach(el => el.textContent = cart.item_count);
    btn.textContent = 'Added ✓';
    setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1500);
    openCart();
  } catch(err) {
    btn.textContent = orig;
    btn.disabled = false;
  }
});

// Qty buttons
document.addEventListener('click', e => {
  const btn = e.target.closest('.qb');
  if (!btn) return;
  const wrap = btn.closest('.cd-qty');
  const span = wrap?.querySelector('span');
  if (!span) return;
  const val = parseInt(span.textContent) || 1;
  const isPlus = btn === wrap.querySelectorAll('.qb')[1];
  span.textContent = isPlus ? val + 1 : Math.max(0, val - 1);
});

// Announcement close
document.querySelector('.ann-close')?.addEventListener('click', function() {
  document.getElementById('AnnBar')?.remove();
});

// Product page variant picker
document.querySelectorAll('.var-opts').forEach(group => {
  group.addEventListener('click', e => {
    const btn = e.target.closest('.var-btn');
    if (!btn) return;
    group.querySelectorAll('.var-btn').forEach(b => { b.classList.remove('active'); b.setAttribute('aria-pressed','false'); });
    btn.classList.add('active');
    btn.setAttribute('aria-pressed','true');
  });
});

// Product gallery thumbnails
document.querySelectorAll('.thumb').forEach(thumb => {
  thumb.addEventListener('click', function() {
    document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
    this.classList.add('active');
    const mainImg = document.querySelector('.main-img img');
    if (mainImg && this.querySelector('img')) {
      mainImg.src = this.querySelector('img').src.replace('_80x', '_900x');
    }
  });
});

// Newsletter form
document.querySelector('.nl-form')?.addEventListener('submit', function(e) {
  const btn = this.querySelector('.nl-btn');
  if (btn) { btn.textContent = 'Subscribing...'; }
});

// ══ LOCATION MODAL ══
function showLocModal() {
  var ov = document.getElementById('LocModalOv');
  if (!ov) return;
  ov.setAttribute('style',
    'display:flex !important;' +
    'position:fixed !important;' +
    'top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;' +
    'width:100vw !important;height:100vh !important;' +
    'background:rgba(28,28,28,.65) !important;' +
    'z-index:99999 !important;' +
    'align-items:center !important;' +
    'justify-content:center !important;' +
    'padding:20px !important;' +
    'box-sizing:border-box !important;' +
    'backdrop-filter:blur(4px) !important;'
  );
  document.body.style.overflow = 'hidden';
  if (typeof updatePopularCities === 'function') updatePopularCities();
}
function closeLocModal() {
  var ov = document.getElementById('LocModalOv');
  if (ov) ov.setAttribute('style', 'display:none !important;');
  document.body.style.overflow = '';
}
function changeLocation() {
  showLocModal();
}

// ══ PRODUCT GALLERY ══
var pdCurrentSlide = 0;

function swapMain(index) {
  var slides = document.querySelectorAll('.pd-slide');
  var thumbs = document.querySelectorAll('.pd-thumb');
  if (!slides.length) return;
  slides.forEach(function(s) { s.classList.remove('active'); });
  thumbs.forEach(function(t) { t.classList.remove('active'); });
  if (slides[index]) slides[index].classList.add('active');
  if (thumbs[index]) {
    thumbs[index].classList.add('active');
    thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  pdCurrentSlide = index;
}

function slideGallery(dir) {
  var slides = document.querySelectorAll('.pd-slide');
  if (!slides.length) return;
  var next = (pdCurrentSlide + dir + slides.length) % slides.length;
  swapMain(next);
}

// ══ SEARCH FUNCTIONS ══
function openSearch() {
  var overlay = document.getElementById('SearchOverlay');
  if (!overlay) return;
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  setTimeout(function() {
    var input = document.getElementById('SearchInput');
    if (input) input.focus();
  }, 100);
}

function closeSearch() {
  var overlay = document.getElementById('SearchOverlay');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
  clearSearch();
}

function clearSearch() {
  var input = document.getElementById('SearchInput');
  var clearBtn = document.getElementById('SearchClear');
  var live = document.getElementById('SearchLive');
  var trending = document.getElementById('SearchTrending');
  if (input) input.value = '';
  if (clearBtn) clearBtn.style.display = 'none';
  if (live) { live.style.display = 'none'; live.innerHTML = ''; }
  if (trending) trending.style.display = 'block';
}

function doSearch(query) {
  var input = document.getElementById('SearchInput');
  if (input) { input.value = query; input.dispatchEvent(new Event('input')); }
}

// Search live input handler
document.addEventListener('DOMContentLoaded', function() {
  var input = document.getElementById('SearchInput');
  if (!input) return;
  var clearBtn = document.getElementById('SearchClear');
  var live = document.getElementById('SearchLive');
  var trending = document.getElementById('SearchTrending');
  var timer = null;

  input.addEventListener('input', function() {
    var q = input.value.trim();
    if (clearBtn) clearBtn.style.display = q ? 'block' : 'none';
    clearTimeout(timer);
    if (q.length < 2) {
      if (live) { live.style.display = 'none'; live.innerHTML = ''; }
      if (trending) trending.style.display = 'block';
      return;
    }
    if (trending) trending.style.display = 'none';
    if (live) { live.style.display = 'block'; live.innerHTML = '<p style="padding:20px;text-align:center;color:#999">Searching...</p>'; }
    timer = setTimeout(function() {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!live) return;
          if (products.length === 0) {
            live.innerHTML = '<p style="padding:20px;text-align:center;color:#999">No results for "' + q + '"</p>';
            return;
          }
          live.innerHTML = '<div class="search-results-grid">' + products.map(function(p) {
            var imgUrl = '';
            if(p.featured_image){
              imgUrl = typeof p.featured_image === 'object' ? (p.featured_image.url || '') : p.featured_image;
              if(imgUrl && imgUrl.indexOf('?') === -1) imgUrl = imgUrl + '?width=120';
              else if(imgUrl) imgUrl = imgUrl.replace(/(\?.*$)/, '?width=120');
            }
            var img = imgUrl ? '<img src="' + imgUrl + '" alt="" style="width:52px;height:52px;object-fit:cover;border-radius:6px;flex-shrink:0" onerror="this.style.display=\'none\'">' : '<div style="width:52px;height:52px;background:#f0f0f0;border-radius:6px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:20px">👗</div>';
            return '<a href="' + p.url + '" class="search-result-item" onclick="closeSearch()">' + img + '<div><p style="font-size:14px;font-weight:500;color:#1c1c1c;margin:0 0 4px">' + p.title + '</p><p style="font-size:13px;color:#888;margin:0">' + (p.price ? fcFormatUSD(p.price) : '') + '</p></div></a>';
          }).join('') + '</div>';
        })
        .catch(function() {
          if (live) live.innerHTML = '<p style="padding:20px;text-align:center;color:#999">Search unavailable. <a href="/search?q=' + encodeURIComponent(q) + '">View all results →</a></p>';
        });
    }, 350);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
  });
});

// ══ BUG FIX: removeItem ══
function removeItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: key, quantity: 0})
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    document.querySelectorAll('.cart-badge, #CartCount, #CdCount').forEach(function(el) {
      el.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    });
    document.querySelectorAll('.cart-badge, #CartCount').forEach(function(el) {
      el.textContent = cart.item_count;
    });
    var row = document.querySelector('[data-key="' + key + '"]');
    if (row) row.remove();
    var sub = document.getElementById('CdSubtotal');
    if (sub) sub.textContent = fcFormatUSD(cart.total_price);
    if (cart.item_count === 0) {
      var itemsEl = document.getElementById('CartItems');
      if (itemsEl) {
        itemsEl.innerHTML = '<div class="crt-empty"><div class="crt-empty-icon">🛍</div><p class="crt-empty-title">Your bag is empty</p><p class="crt-empty-sub">Looks like you haven\'t added anything yet.</p><a href="/collections/all" class="crt-empty-btn" onclick="closeCart()">Explore Collection →</a></div>';
      }
      var foot = document.querySelector('.crt-foot');
      if (foot) foot.style.display = 'none';
    }
    updateFsBar(cart.total_price / 100);
  })
  .catch(function(err) { if (window.FC_DEBUG) { console.error('removeItem failed:', err); } });
}

// ══ BUG FIX: changeQty ══
function changeQty(key, newQty) {
  if (newQty < 0) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: key, quantity: newQty})
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    fetch('/cart', {headers: {'Accept': 'text/html'}})
      .then(function(r) { return r.text(); })
      .catch(function() {});
    document.querySelectorAll('.cart-badge, #CartCount').forEach(function(el) {
      el.textContent = cart.item_count;
    });
    var row = document.querySelector('[data-key="' + key + '"]');
    if (row) {
      var qtyNum = row.querySelector('.crt-qty-num');
      if (qtyNum) qtyNum.textContent = newQty;
      var item = cart.items && cart.items.find(function(i) { return i.key === key; });
      if (item) {
        var priceEl = row.querySelector('.crt-price-final');
        if (priceEl) priceEl.textContent = fcFormatUSD(item.final_line_price);
      }
      if (newQty === 0) { row.remove(); }
    }
    var sub = document.getElementById('CdSubtotal');
    if (sub) sub.textContent = fcFormatUSD(cart.total_price);
    var countEl = document.getElementById('CdCount');
    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    updateFsBar(cart.total_price / 100);
    if (cart.item_count === 0) {
      var itemsEl = document.getElementById('CartItems');
      if (itemsEl) itemsEl.innerHTML = '<div class="crt-empty"><div class="crt-empty-icon">🛍</div><p class="crt-empty-title">Your bag is empty</p><p class="crt-empty-sub">Looks like you haven\'t added anything yet.</p><a href="/collections/all" class="crt-empty-btn" onclick="closeCart()">Explore Collection →</a></div>';
      var foot = document.querySelector('.crt-foot');
      if (foot) foot.style.display = 'none';
    }
  })
  .catch(function(err) { if (window.FC_DEBUG) { console.error('changeQty failed:', err); } });
}

// Helper: update free shipping bar
function updateFsBar(total) {
  var threshold = 99;
  var fill = document.getElementById('CdFsFill');
  var msg = document.getElementById('CdFsMsg');
  if (!fill && !msg) return;
  var pct = Math.min((total / threshold) * 100, 100);
  if (fill) fill.style.width = pct + '%';
  if (total >= threshold) {
    if (msg) msg.innerHTML = '🎁 Free US shipping applied to your order!';
  } else {
    var rem = Math.ceil(threshold - total);
    if (msg) msg.innerHTML = 'Add <strong>$' + rem.toFixed(2) + '</strong> more for <strong>FREE US Shipping</strong> 🚚';
  }
}

// ── Product Card: Add to Cart (AJAX) ──
window.pcAddToCart = function(btn, variantId) {
  if (!variantId || !btn) return;
  var label = btn.querySelector('.pc-btn-label');
  var originalHTML = btn.innerHTML;
  var originalLabel = label ? label.textContent : '';
  btn.disabled = true;
  btn.classList.add('is-loading');
  if (label) label.textContent = 'Adding...';
  else btn.textContent = 'Adding...';

  fetch((window.fcRoute ? window.fcRoute('cart/add.js') : '/cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
  .then(function(r) {
    if (!r.ok) throw new Error('Cart add failed');
    return r.json();
  })
  .then(function() {
    var currentLabel = btn.querySelector('.pc-btn-label');
    if (currentLabel) currentLabel.textContent = '✓ Added';
    else btn.textContent = '✓ Added';

    fetch((window.fcRoute ? window.fcRoute('cart.js') : '/cart.js'))
      .then(function(r) { return r.json(); })
      .then(function(c) {
        document.querySelectorAll('.cart-badge, #CartCount, [data-cart-count]').forEach(function(el) {
          el.textContent = c.item_count;
        });
        if (typeof openCart === 'function') openCart();
      });

    setTimeout(function() {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (btn.querySelector('.pc-btn-label')) btn.querySelector('.pc-btn-label').textContent = originalLabel || 'Add to Bag';
      else btn.innerHTML = originalHTML;
    }, 1800);
  })
  .catch(function() {
    btn.disabled = false;
    btn.classList.remove('is-loading');
    btn.innerHTML = originalHTML;
    window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
  });
};

// ── Product Card: Buy Now ──
window.showQuickBuyModal = function(variantId, handle) {
  if (!variantId) { window.location.href = (window.fcProductUrl ? window.fcProductUrl(handle) : '/products/' + encodeURIComponent(handle || '')); return; }
  fetch((window.fcRoute ? window.fcRoute('cart/add.js') : '/cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(function() { window.location.href = '/checkout'; })
  .catch(function() {
    window.location.href = (window.fcProductUrl ? window.fcProductUrl(handle, variantId) : '/products/' + encodeURIComponent(handle) + '?variant=' + encodeURIComponent(variantId));
  });
};

// ══ BUG FIX: toggleDarkMode ══
(function() {
  var DARK_KEY = 'fc_dark_mode';

  function applyDark(on) {
    document.documentElement.classList.toggle('dark-mode', on);
    document.body.classList.toggle('dark-mode', on);
    var icon = document.getElementById('DarkIcon');
    if (icon) icon.textContent = on ? '☀️' : '🌙';
    localStorage.setItem(DARK_KEY, on ? '1' : '0');
  }

  if (localStorage.getItem(DARK_KEY) === '1') {
    applyDark(true);
  }

  window.toggleDarkMode = function() {
    var isDark = document.documentElement.classList.contains('dark-mode');
    applyDark(!isDark);
  };
})();

/* ── Mega Menu Tab Switching ── */
(function() {
  function initMegaTabs() {
    document.querySelectorAll('.md-tab').forEach(function(tab) {
      tab.addEventListener('mouseenter', function() {
        var panelId = this.getAttribute('data-mega');
        var drop = this.closest('.mega-drop');
        if (!drop || !panelId) return;
        drop.querySelectorAll('.md-tab').forEach(function(t) {
          t.classList.remove('md-tab--active');
        });
        this.classList.add('md-tab--active');
        drop.querySelectorAll('.md-panel').forEach(function(p) {
          p.classList.remove('md-panel--active');
        });
        var target = drop.querySelector('#md-' + panelId);
        if (target) target.classList.add('md-panel--active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaTabs);
  } else {
    initMegaTabs();
  }
})();


/* ── Bind buttons on DOMContentLoaded ── */
document.addEventListener('DOMContentLoaded', function() {
  /* Search button */
  var searchBtn = document.getElementById('fc-search-open');
  if (searchBtn) searchBtn.addEventListener('click', openSearch);

  /* Cart header button — backup listener if onclick missing */
  var cartBtn = document.getElementById('CartToggle');
  if (cartBtn) cartBtn.addEventListener('click', openCart);
});


  // Native compact layout is controlled by CSS dimensions; no page zoom is used.
  
